export const USER_POST = 'USER_POST'
export const USER_UPDATE = 'USER_UPDATE'
export const USER_ERROR = 'USER_ERROR'

export function addUser(payload = {}) {
  return {
    type: USER_POST,
    payload,
  }
}

export function updateUser(payload = {}) {
  return {
    type: USER_UPDATE,
    payload,
  }
}

export function errorUser(payload = {}) {
  return {
    type: USER_ERROR,
    payload,
  }
}
